<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<app-more-sections label="shared|identity-card|title">
			<div>
				<app-input-field
					formControlName="identityDocumentNumber"
					[label]="'customers|record|driver-section|field-label|identity-document-number'" />
			</div>

			<div>
				<app-single-dropdown
					formControlName="identityDocumentType"
					[label]="'customers|record|driver-section|dropdown-label|identity-document-type'"
					[selectOptions]="customerIdentityDocumentTypes" />

				<app-single-dropdown
					[selectOptions]="countries"
					formControlName="identityDocumentIssuedByCountryId"
					[label]="'customers|record|driver-section|dropdown-label|identity-document-issued-by-country'" />
			</div>

			<div>
				<app-datetime-picker
					[showTime]="false"
					[excludeFutureDates]="true"
					formControlName="identityDocumentIssueDate"
					[label]="'customers|record|driver-section|field-label|identity-document-issue-date'" />
				<app-datetime-picker
					[showTime]="false"
					[excludePastDates]="true"
					formControlName="identityDocumentExpiryDate"
					[label]="'customers|record|driver-section|field-label|identity-document-expiry-date'" />
			</div>
		</app-more-sections>

		<app-more-sections label="shared|driving-license|title">
			<div class="w-full flex justify-end">
				<button
					type="button"
					ultra-primary
					color="primary"
					svgIcon="add"
					[disabled]="!isEditMode"
					[content]="'customers|record|driver-section|action|add-driving-license'"
					(click)="addDrivingLicense()"></button>
			</div>

			<div
				formArrayName="drivingLicenses"
				class="flex flex-col gap-4 items-center">
				@for (
					license of drivingLicenses.controls;
					track licenseTrackBy($index, license)
				) {
					<app-stack-item-container
						class="w-full max-w-2xl"
						allowDelete
						[disableDelete]="!isEditMode || drivingLicenses.length <= 1"
						(onDeleteClicked)="removeDrivingLicense(license)">
						<div class="title-area">
							<span class="p-2">{{
								'shared|driving-license|title' | transloco
							}}</span>
						</div>
						<div class="um-section-parent-container" [formGroupName]="$index">
							<div>
								<app-toggle-new
									[disabled]="drivingLicenses.length <= 1"
									formControlName="isPrimary"
									[label]="'customers|record|driver-section|label|primary-driving-license'" />
							</div>

							<div>
								<app-input-field
									formControlName="number"
									[label]="'customers|record|driver-section|field-label|driving-license-number'" />

								<app-input-field
									formControlName="category"
									[label]="'customers|record|driver-section|field-label|driving-license-category'" />
							</div>

							<div>
								<app-single-dropdown
									[selectOptions]="countries"
									formControlName="issuedByCountryId"
									[label]="'customers|record|driver-section|dropdown-label|driving-license-issued-by-country'" />
							</div>

							<div>
								<app-datetime-picker
									formControlName="issueDate"
									[showTime]="false"
									[excludeFutureDates]="true"
									[label]="'customers|record|driver-section|field-label|driving-license-issue-date'" />

								<app-datetime-picker
									formControlName="expiryDate"
									[showTime]="false"
									[excludePastDates]="true"
									[label]="'customers|record|driver-section|field-label|driving-license-expiry-date'" />
							</div>
						</div>
					</app-stack-item-container>
				}
			</div>
		</app-more-sections>
	</form>
</app-section-wrapper-container>
